export default class MaintenanceError extends Error {}
